const tagType = {
  TAG_GROUP: 'tag-group',
  TAG: 'tag',
};

export default tagType;
